import { ChangeEvent } from 'react';
import { Box, Icon } from '@nimbus-ds/components';
import { MoneyIcon } from '@nimbus-ds/icons';
import { InputNumberNimbus } from 'commons/components';

interface InputWithErrorProps {
  hasError: boolean;
  handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  discount: string;
  discountNumber: number | undefined;
  maxDiscount: number;
}

function InputWithError({
  hasError,
  handleInputChange,
  discount,
}: Readonly<InputWithErrorProps>) {
  return (
    <Box>
      <InputNumberNimbus
        appearance={hasError ? 'danger' : 'neutral'}
        type="float2d"
        onChange={handleInputChange}
        append={<Icon source={<MoneyIcon color="grey" />} />}
        defaultDecimals={2}
        value={discount}
        decimalSeparator=","
      />
    </Box>
  );
}

export default InputWithError;
